export const faqs = [
  {
    question: 'Who can benefit from ClassroomIO?',
    answer:
      'We built ClassroomIO from the ground up for Educators, meaning if you teach online or in a physical classroom you are good to go. It works best for Educators who already have students and want an efficient way to manage their learning experience.',
  },
  {
    question: 'Will I be able to set up ClassroomIO without technical skills?',
    answer:
      'Most definitely. You can use ClassroomIO as a no-code tool to build your own LMS platform. We provide an intuitive user interface and documentation to help you give your students the best learning experience.',
  },
  {
    question: 'How much customization can I do with ClassroomIO?',
    answer:
      'Things like theming, organization name, landing pages, content that your students see and many more customization options to come.',
  },
  {
    question: 'Is ClassroomIO suitable for a large number of students?',
    answer:
      'Absolutely. ClassroomIO is built for a large number of students in any course. You can have multiple courses with as many students as you need.',
  },
  {
    question: 'What kind of team plans does ClassroomIO offer?',
    answer:
      'ClassroomIO offers a Team plan designed to cater to organizations of any size. Depending on the plan you select, you can invite other teachers into your organization.',
  },
  {
    question: 'Can I try ClassroomIO before I buy it?',
    answer:
      'Definitely. We’ve got a generous free plan to help you get started with the platform. As your requirements grow, we’ve got other plans that can grow with you.',
  },
];
